<div class="row w-100">
    <!-- SIDEBAR -->
    <div class="col-12 col-xl-3 colSideBar">
        <app-sidebar [nbStep]="nbStep" [step]="stepNb"></app-sidebar>
    </div>


    <!-- PREMIER ECRAN -->
    <!-- Form Step 1 (enfant) -->
    <div *ngIf="step === 'young'" class="col formGroupStepYoung">
        <div class="row">
            <div class="offset-1 col-6">
                <p class="form_title">Votre enfant</p>
            </div>
        </div>
        <div class="row justify-content-start">
            <div class="offset-1 col-10 col-lg-5">
                <app-input-text [control]="fStep1Young.lastName"
                                [group]="formGroupStepYoung"
                                [required]=true
                                [submitted]="formYoungSubmitted"
                                errorMsg="Le nom est obligatoire"
                                fcName="lastName"
                                placeholder="Entrez le nom de l'enfant"
                                textLabel="Nom de l'enfant">
                </app-input-text>
            </div>
            <div class="offset-1 col-10 offset-lg-0 col-lg-5">
                <app-input-text [control]="fStep1Young.firstName"
                                [group]="formGroupStepYoung"
                                [required]="true"
                                [submitted]="formYoungSubmitted"
                                errorMsg="Le prénom est obligatoire"
                                fcName="firstName"
                                placeholder="Entrez le prénom de l'enfant"
                                textLabel="Prénom de l'enfant">
                </app-input-text>
            </div>
        </div>
        <div class="row align-items-start">
            <div class="offset-1 col-10 col-lg-5">
                <div class="row">
                    <div class="col-12">
                        <label class="label-info star">Sexe</label>
                        <mat-error *ngIf="!sexValidator && formYoungSubmitted" class="errorLabelMatError float-right">
                            Veuillez renseigner le sexe
                        </mat-error>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div [formGroup]="formGroupStepYoung" class="form-group">
                            <div class="flex-group">
                                <mat-checkbox
                                        (change)="onMaleSelect($event)"
                                        [ngClass]="{'is-invalid': fStep1Young.sexMale.invalid && formYoungSubmitted}"
                                        color="primary"
                                        formControlName="sexMale"
                                        id="checkboxSexeMale">
                                </mat-checkbox>
                                <label class="label-info" for="checkboxSexeMale"> Garçon </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div [formGroup]="formGroupStepYoung" class="form-group">
                            <div class="flex-group" >
                                <mat-checkbox
                                        (change)="onFemaleSelect($event)"
                                        [ngClass]="{'is-invalid': fStep1Young.sexFemale.invalid && formYoungSubmitted}"
                                        color="primary"
                                        formControlName="sexFemale"
                                        id="checkboxSexeFemale">
                                </mat-checkbox>
                                <label class="label-info" for="checkboxSexeFemale"> Fille </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="offset-1 col-10 offset-lg-0 col-lg-5">
                <div [formGroup]="formGroupStepYoung" class="form-group">
                    <label class="label-info star">Date de naissance</label>

                    <div class="input-group">
                        <input #birthdayInput
                               [errorStateMatcher]="birthdayMatcher"
                               [matDatepicker]="birthday"
                               [max]="minBirthdayDate"
                               [ngClass]="{'is-invalid': fStep1Young.birthday.invalid && formYoungSubmitted}"
                               autocomplete="off"
                               class="form-control"
                               formControlName="birthday"
                               matInput
                               placeholder="ex: 01/01/2000"
                        >
                        <div class="input-group-append">
                            <button (click)="birthday.open()" class="btn btn-outline-secondary form-control">
                                <mat-icon>calendar_month</mat-icon>
                            </button>
                        </div>
                    </div>
                    <mat-datepicker
                        #birthday></mat-datepicker>
                    <div *ngIf="fStep1Young.birthday.hasError('required') && formYoungSubmitted"
                         class="invalid-feedback d-block pb-2">
                        <div>La date de naissance est obligatoire</div>
                    </div>

                    <div *ngIf="isBirthdayFalse()" class="errorLabelMatError">
                        <div>Le jeune doit avoir au minimum 6 ans pour s'inscrire</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            @if (isOlderThan17) {
            <ng-template #emailLabel><label class="label-info labelForm star">Email <strong>de l'enfant</strong></label></ng-template>
            <app-input-text [control]="fStep1Young.mail"
                            [group]="formGroupStepYoung"
                            [submitted]="formYoungSubmitted"
                            [templateLabel]="emailLabel"
                            class="offset-1 col-10 col-lg-5"
                            errorMsg="Un email est obligatoire pour les jeunes majeurs."
                            errorMsg2="L'email entré n'a pas le bon format, ou n'est pas disponible."
                            fcName="mail"
                            placeholder="ex: someone@example.com"
            ></app-input-text>
            }
            <div [ngClass]="isOlderThan17 ? 'offset-lg-0' : 'offset-lg-1'"
                 class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 col-lg-5">
                <label [ngClass]="{'star' : isOlderThan17}" class="label-info labelForm">Numéro de téléphone <strong>de
                    l'enfant</strong>
                  @if(!isOlderThan17) {<br>(laisser vide s'il n'en a pas)}</label>
                <div class="row w-100 m-0">
                    <div class="col-4 col-sm-3 col-md-3 col-lg-5 col-xl-4 pl-0">
                        <app-select [group]="formGroupStepYoung" [items]="phoneRegionCodeForSelect"
                                    fcName="phoneCode"></app-select>
                    </div>
                    <div class="col-8 col-sm-7 col-md-7 col-lg-7 col-xl-8 p-0">
                        <app-input-text [control]="fStep1Young.phone"
                                        [group]="formGroupStepYoung"
                                        [submitted]="formYoungSubmitted"
                                        errorMsg="Un numéro de téléphone est obligatoire pour les jeunes majeurs."
                                        errorMsg2="Le numéro de téléphone entré n'a pas le bon format, ou n'est pas disponible."
                                        fcName="phone"
                                        placeholder="ex: 0612345678"></app-input-text>
                    </div>
                </div>
            </div>
        </div>
        <!-- Number of brother - sister - child -->
        <div class="row">
            <app-select-number [control]="fStep1Young.numberBrother"
                               [group]="formGroupStepYoung"
                               class="offset-1 col-10 col-lg-3"
                               fcName="numberBrother"
                               textLabel="Nombre de frère(s)"></app-select-number>
            <app-select-number [control]="fStep1Young.numberSister"
                               [group]="formGroupStepYoung"
                               class="offset-1 col-10 offset-lg-0 col-lg-3"
                               fcName="numberSister"
                               textLabel="Nombre de sœur(s)"></app-select-number>
            <app-select-number [control]="fStep1Young.childs"
                               [group]="formGroupStepYoung"
                               class="offset-1 col-10 offset-lg-0 col-lg-4"
                               fcName="childs"
                               textLabel="Enfant(s) à charge"></app-select-number>
        </div>
        <div class="row">
            <div class="form-group col-10 col-lg-2 offset-1">
                <label class="label-info labelForm">Année scolaire</label>
                <input [value]="formatScolarDate()" class="form-control" disabled type="text"/>
            </div>
            <div class="form-group col-10 col-lg-4 offset-1 offset-lg-0">
                <label class="label-info star labelForm">Classe</label>
                <select (ngModelChange)="onChangeLevel($event)"
                        [(ngModel)]="chosenSchoolLevel"
                        [ngClass]="{'is-invalid': isInvalidSchoolLevel}"
                        class="custom-select b">
                    <option *ngFor="let item of schoolLevelForSelect" [ngValue]="item.id"
                            class="no-white-space">{{ item.name }}
                    </option>
                </select>
                <div *ngIf="isInvalidSchoolLevel" class="invalid-feedback d-block">
                    <div>La classe est obligatoire</div>
                </div>
            </div>
            <div [formGroup]="formGroupStepYoung" class="form-group col-10 col-lg-4 offset-1 offset-lg-0">
                <label class="label-info labelForm">Établissement</label>
                <input class="form-control" formControlName="etablissement" type="search">
            </div>
        </div>

        <div class="row">
            <div class="form-group col-10 offset-1 col-lg-5">
                <app-select-multiple
                    [disabled]="
                        !scolarDifficultyForSelect ||
                        scolarDifficultyForSelect.length === 0
                    "
                    [group]="formGroupStepYoung"
                    fcName="scolarDifficulty"
                    [items]="scolarDifficultyForSelect"
                    class="justify-content-center align-items-start"
                    textLabel="Difficulté(s) scolaire(s)"
                />
            </div>
            @if (hasSchoolDifficulties) {
            <div class="form-group col-10 col-lg-5 offset-1 offset-lg-0">
                <app-select-multiple
                    [disabled]="
                        !disciplineScolarDifficultyForSelect ||
                        disciplineScolarDifficultyForSelect.length === 0
                    "
                    [group]="formGroupStepYoung"
                    fcName="disciplineScolarDifficulty"
                    [items]="disciplineScolarDifficultyForSelect"
                    class="justify-content-center align-items-start"
                    textLabel="Matière(s)"
                    [required]="true"
                    [error]="isInvalidDisciplineDIfficulteScolaire"
                    errorMsg="La matière est obligatoire"
                />
            </div>
            }
        </div>

        <div class="row">
            <app-switch [group]="formGroupStepYoung" class="offset-1 col-sm-10 col-md-5 d-flex align-items-center"
                        fcName="handicap"
                        textLabel="Jeune en situation d'handicap"></app-switch>

            <app-input-text [control]="fStep1Young.medicalObservation"
                            [group]="formGroupStepYoung"
                            class="offset-1 col-sm-10 offset-md-0 col-md-5 "
                            fcName="medicalObservation"
                            textLabel="Observation(s) médicale(s)">
            </app-input-text>
        </div>
        <div class="row">
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                <div class="form-group">
                    <label class="label-info labelForm star">Adresse</label>
                    <app-input-text-google-autocomplete [control]="fStep1Young.address1"
                                                        [group]="formGroupStepYoung"
                                                        [submitted]="formYoungSubmitted"
                                                        fcName="address1">
                    </app-input-text-google-autocomplete>
                    <div *ngIf="fStep1Young.address1.hasError('required') && formYoungSubmitted"
                         class="invalid-feedback d-block">
                        <div>L'adresse est obligatoire</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <app-input-text [control]="fStep1Young.zipCode"
                            [group]="formGroupStepYoung"
                            [required]="true"
                            [submitted]="formYoungSubmitted"
                            class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-5 offset-lg-1 col-lg-5"
                            errorMsg="Le code postal est obligatoire"
                            fcName="zipCode"
                            placeholder="Saisissez un code postal"
                            textLabel="Code Postal"
            ></app-input-text>
            <app-input-text [control]="fStep1Young.city"
                            [group]="formGroupStepYoung"
                            [required]="true"
                            [submitted]="formYoungSubmitted"
                            class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-0 col-md-5 offset-lg-0 col-lg-5"
                            errorMsg="La ville est obligatoire"
                            fcName="city"
                            placeholder="Saisissez une ville"
                            textLabel="Ville">
            </app-input-text>
        </div>
        <div class="row">
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                <app-alert [id]="'alert-step-1'"></app-alert>
            </div>
        </div>
        <div class="row">
          <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
            <app-alert [id]="'alert-step-1-email'"></app-alert>
          </div>
        </div>
        <div class="row">
          <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
            <app-alert [id]="'alert-step-1-phone'"></app-alert>
          </div>
        </div>
        <div class="row">
            <div class="offset-2 col-8 offset-sm-2 col-sm-8 offset-md-6 col-md-5 offset-lg-6 col-lg-5 mb-3">
                <button (click)="goNextStep()" [disabled]="blockNextYoung()" class="btn btn-primary btn-lg btn-block">
                    Suivant
                </button>
            </div>
        </div>
    </div>

    <!-- SECOND ECRAN -->
    <!-- Form Step 2 (Responsable) -->
    <div *ngIf="step === 'resp'" class="col formGroupStepResp">
        <div class="row">
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-5">
                <p *ngIf="!isDoubleResponsable" class="form_title">Responsable</p>
                <p *ngIf="isDoubleResponsable && isFirstResponsable" class="form_title">Responsable 1</p>
                <p *ngIf="isDoubleResponsable && !isFirstResponsable" class="form_title">Responsable 2</p>
            </div>
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-0 col-lg-5 mb-3 text-right">

              <button *ngIf="isOlderThan17" (click)="stepPlaceWithoutResp(true)" class="btn btn-outline-danger mb-3" type="button">
                Passer - Ne pas enregistrer de Responsable
              </button>
             <div>
              <button (click)="addResponsable()" *ngIf="!isDoubleResponsable" class="btn btn-outline-primary"
                        type="button">
                    <span id="btnDoubleRespText">Ajouter un second responsable légal</span>
                </button>
                <button (click)="switchResponsable()" *ngIf="isDoubleResponsable && isFirstResponsable"
                        class="btn btn-primary mr-2 col-5">
                    <span>Responsable 2</span>
                </button>
                <button (click)="switchResponsable()" *ngIf="isDoubleResponsable && !isFirstResponsable"
                        class="btn btn-success mr-2 col-5">
                    <span>Responsable 1</span>
                </button>
                <button (click)="cancelAdd()" *ngIf="isDoubleResponsable" class="btn btn-outline-secondary col-5">
                    <span>Annuler ajout</span>
                </button>
             </div>
            </div>
        </div>
        <div [formGroup]="formGroupStepResp">
            <div class="row">
                <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-5 offset-lg-1 col-lg-5">
                    <app-input-text [control]="fStep2Resp.lastName"
                                    [group]="formGroupStepResp"
                                    [required]="true"
                                    [submitted]="formRespSubmitted"
                                    errorMsg="Le nom est obligatoire"
                                    fcName="lastName"
                                    placeholder="Entrez le nom du responsable"
                                    textLabel="Nom">
                    </app-input-text>
                </div>
                <div class="offset-1 col-10 offset-md-0 col-md-5 offset-lg-0 col-lg-5">
                    <app-input-text [control]="fStep2Resp.firstName"
                                    [group]="formGroupStepResp"
                                    [required]="true"
                                    [submitted]="formRespSubmitted"
                                    errorMsg="Le prénom est obligatoire"
                                    fcName="firstName"
                                    placeholder="Entrez le prénom du responsable"
                                    textLabel="Prénom">
                    </app-input-text>
                </div>
            </div>
            <div class="row">
                <div class="offset-1 col-10">
                    <div class="row">
                        <div class="col-12">
                            <label class="label-info star">Sexe</label>
                            <mat-error *ngIf="!sexRespValidator && formRespSubmitted" class="errorLabelMatError ml-2">
                                (Veuillez renseigner le sexe)
                            </mat-error>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="offset-1 col-10 offset-sm-1 col-sm-2 offset-md-1 col-md-2 offset-lg-1 col-lg-2 mr-3">
                    <div [formGroup]="formGroupStepResp"
                         class="custom-control custom-radio sexeSelection">
                        <input [value]="sexeEnum.MAN"
                               class="custom-control-input"
                               formControlName="sex"
                               id="idRadioBtn1"
                               name="sex"
                               type="radio">
                        <label class="custom-control-label"
                               for="idRadioBtn1"> Homme </label>
                    </div>
                </div>
                <div class="offset-1 col-10 offset-sm-0 col-sm-2 offset-md-0 col-md-2 offset-lg-0 col-lg-2 mr-3">
                    <div [formGroup]="formGroupStepResp"
                         class="custom-control custom-radio sexeSelection">
                        <input [value]="sexeEnum.WOMAN"
                               class="custom-control-input"
                               formControlName="sex"
                               id="idRadioBtn2"
                               name="sex"
                               type="radio">
                        <label class="custom-control-label"
                               for="idRadioBtn2"> Femme </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-5 offset-lg-1 col-lg-5">
                    <app-select [control]="fStep2Resp.familySituation"
                                [group]="formGroupStepResp"
                                [items]="familySituationForSelect"
                                [required]="true"
                                [submitted]="formRespSubmitted"
                                fcName="familySituation"
                                textLabel="Statut familial">
                    </app-select>
                </div>
                <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-0 col-md-5 offset-lg-0 col-lg-5">
                    <app-input-text [control]="fStep2Resp.job"
                                    [group]="formGroupStepResp"
                                    [required]="false"
                                    [submitted]="formRespSubmitted"
                                    errorMsg=""
                                    fcName="job"
                                    placeholder="Saisissez votre métier"
                                    textLabel="Métier">
                    </app-input-text>
                </div>
            </div>
            <div class="row">
                <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-5">
                  <label class="label-info labelForm star">Email</label>
                    <app-input-text [control]="fStep2Resp.mail"
                                    [group]="formGroupStepResp"
                                    [submitted]="formRespSubmitted"
                                    errorMsg="Veuillez entrer une adresse mail"
                                    errorMsg2="L'email entré n'a pas le bon format"
                                    fcName="mail"
                                    placeholder="ex: someone@example.com"></app-input-text>
                </div>
                <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-0 col-lg-5">
                    <label class="label-info labelForm star">Numéro de téléphone portable</label>
                    <div class="row w-100 m-0">
                        <app-select [group]="formGroupStepResp"
                                    [items]="phoneRegionCodeForSelect"
                                    class="col-4 col-sm-3 col-md-3 col-lg-5 col-xl-4 pl-0"
                                    fcName="phoneCode"></app-select>
                        <app-input-text [control]="fStep2Resp.phone"
                                        [group]="formGroupStepResp"
                                        [submitted]="formRespSubmitted"
                                        class="col-8 col-sm-7 col-md-7 col-lg-7 col-xl-8 p-0"
                                        errorMsg="Veuillez entrer un numéro de téléphone"
                                        errorMsg2="Le numéro de téléphone entré n'a pas le bon format"
                                        fcName="phone"
                                        placeholder="ex: 0612345678"></app-input-text>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                    <div class="form-group">
                        <label class="label-info labelForm star">Adresse</label>
                        <app-input-text-google-autocomplete [control]="fStep2Resp.address1"
                                                            [group]="formGroupStepResp" [submitted]="formRespSubmitted"
                                                            fcName="address1">
                        </app-input-text-google-autocomplete>
                        <div *ngIf="fStep2Resp.address1.hasError('required') && formRespSubmitted"
                             class="invalid-feedback d-block">
                            <div>L'adresse est obligatoire</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-5 offset-lg-1 col-lg-5">
                    <app-input-text [control]="fStep2Resp.zipCode"
                                    [group]="formGroupStepResp"
                                    [placeholder]=""
                                    [required]="true"
                                    [submitted]="formRespSubmitted"
                                    class="nowrap"
                                    errorMsg="Le code postal est obligatoire"
                                    fcName="zipCode"
                                    textLabel="Code Postal"></app-input-text>
                </div>
                <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-0 col-md-5 offset-lg-0 col-lg-5">
                    <app-input-text [control]="fStep2Resp.city"
                                    [group]="formGroupStepResp"
                                    [placeholder]=""
                                    [required]="true"
                                    [submitted]="formRespSubmitted"
                                    errorMsg="La ville est obligatoire"
                                    fcName="city"
                                    textLabel="Ville"></app-input-text>
                </div>
            </div>
            <div class="row">
                <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                    <app-alert [id]="'alert-step-2'"></app-alert>
                </div>
            </div>
            <div class="row">
              <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                <app-alert [id]="'alert-step-2-phone'"></app-alert>
              </div>
            </div>
            <div class="row">
              <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                <app-alert [id]="'alert-step-2-email'"></app-alert>
              </div>
            </div>
            <div class="row">
                <div class="offset-2 col-8 offset-sm-2 col-sm-8 offset-md-1 col-md-5 offset-lg-1 col-lg-5 mb-3">
                    <button (click)="back()" class="btn btn-secondary btn-lg btn-block" type="button">
                        Retour
                    </button>
                </div>
                <div class="offset-2 col-8 offset-sm-2 col-sm-8 offset-md-0 col-md-5 offset-lg-0 col-lg-5 mb-3">

                    <button (click)="goNextStep()" [disabled]="blockNextStep()"
                            class="btn btn-primary btn-lg btn-block"
                            type="button">
                        Suivant
                    </button>
                  @if (this.errorsCanGoNext?.length>0) {
                    <div class="alert alert-danger mt-3" role="alert">
                      <ul>
                        <li *ngFor="let error of errorsCanGoNext">{{error}}</li>
                      </ul>
                    </div>
                  }
                </div>
                <div *ngIf="isOlderThan17"
                     class="offset-2 col-8 offset-md-0 col-md-5 offset-lg-0 mx-md-auto mb-3">
                  <button (click)="stepPlaceWithoutResp(true)" class="btn btn-lg btn-outline-danger" type="button">
                    Passer - Ne pas enregistrer de Responsable
                  </button>
                </div>
            </div>
        </div>
    </div>

    <!-- TROISIEME ECRAN -->
    <!-- Form Step 3 -->
    <div *ngIf="step === 'place'" class="col formGroupStepPlace">
        <div class="row">
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                <p class="form_title">Activité</p>
            </div>
        </div>
        <div class="row align-items-center">
            <div *ngIf="!isEventAdd" [formGroup]="formGroupStepPlace"
                 class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-5">
                <app-input-text (click)="openModalPlace()"
                                [control]="fStep3Place.nameCenter"
                                [group]="formGroupStepPlace"
                                [required]="true"
                                [submitted]="formPlaceSubmitted"
                                errorMsg="Saisissez un centre"
                                fcName="nameCenter"
                                textLabel="Centre"></app-input-text>
            </div>

            <div *ngIf="isEventAdd" [formGroup]="formGroupStepPlace"
                 class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-4">
                <app-input-text (click)="openModalPlace()"
                                [control]="fStep3Place.nameCenter"
                                [group]="formGroupStepPlace"
                                [required]="true"
                                [submitted]="formPlaceSubmitted"
                                errorMsg="Saisissez un centre"
                                fcName="nameCenter"
                                textLabel="Centre"></app-input-text>
            </div>
        </div>
        <div class="row">
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10 pt-2">
                <app-select [control]="fStep3Place.program"
                            [group]="formGroupStepPlace"
                            [items]="programForSelect"
                            [required]="true"
                            [submitted]="formPlaceSubmitted"
                            errorMsg="Saisissez un programme dans la liste"
                            fcName="program"
                            textLabel="Programme">
                </app-select>
            </div>
        </div>
        <div class="row">
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                <label class="label-info labelForm star">Activité</label>
                <mat-accordion class="young-register-event">
                    <mat-expansion-panel [disabled]="!canChooseEvent" [ngClass]="{'disabled':!canChooseEvent}">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Sélectionnez une activité</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                            <app-grid-event-multi-select (selectionChange)="onSelectionChange($event)"
                                                         [defaultSelection]="defaultSelection"
                                                         [eventList]="eventList"></app-grid-event-multi-select>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
        <div class="row">
            <div class="offset-1 col-11 offset-sm-1 col-sm-1 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                <ng-container #container></ng-container>
            </div>
        </div>
        <div class="row">
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                <app-alert id="alert-step-3"></app-alert>
            </div>
        </div>
        <div *ngIf="!isEventAdd" class="row">
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 col-md-5 col-lg-5">
                <button (click)="back()" [disabled]="isLoading" class="btn btn-secondary btn-lg btn-block mt-3"
                        type="button">
                    Retour
                </button>
            </div>
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-0 col-md-5 offset-lg-0 col-lg-5">
                <button (click)="validForm()" *ngIf="!isLoading" class="btn btn-primary btn-lg btn-block mt-3"
                        type="button">
                    Valider
                </button>
                <button *ngIf="isLoading" class="btn btn-primary btn-lg btn-block buttonLoadingSpinner mt-3"
                        type="button">
                    <mat-spinner [diameter]="30" class="loadingSpinner"></mat-spinner>
                </button>
            </div>
        </div>
        <div *ngIf="isEventAdd" class="row">
            <div class="offset-3 col-6 offset-sm-3 col-sm-6 offset-md-3 col-md-6 offset-lg-3 col-lg-6 mb-3">
                <button (click)="validForm()" *ngIf="!isLoading" class="btn btn-primary btn-lg btn-block mt-3"
                        type="button">
                    Valider
                </button>
                <button *ngIf="isLoading" class="btn btn-primary btn-lg btn-block buttonLoadingSpinner mt-3"
                        type="button">
                    <mat-spinner [diameter]="30" class="loadingSpinner"></mat-spinner>
                </button>
            </div>
        </div>
    </div>

    <!-- ECRAN Modification Jeune-->
    <!-- Step 2 -->
    <div *ngIf="isEventAdd && this.step === 'modificationYoung' " class="col formGroupStepResp">
        <div class="row">
            <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
                <p class="form_title">
                    <span>{{ this.userToRegister.userRegistered.firstName + " " + this.userToRegister.userRegistered.lastName.toUpperCase() }}</span>
                </p>
            </div>
        </div>

        <app-inscription-information-young (nextStep)="parentNextStepModificationYoung()"
                                           [pSchoolLevelsAllValues]="this.pSchoolLevelsAllValues"
                                           [pSchoolLevelsArray]="this.pSchoolLevelsArray"
                                           [young]="this.youngWithDataForModification"
        ></app-inscription-information-young>
    </div>
</div>
